var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"inner-page"},[_c('Header',[_c('div',[_vm._v("关于音网")])]),_c('div',{staticClass:"page-content"},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":""}})]),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }